
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import SquareShadowBox from "@/components/SquareShadowBox.vue";
import { BIconPrinter } from "bootstrap-vue";
import VueQRCodeComponent from "vue-qrcode-component";
import EstadoAseguradora from "@/enums/EstadoAseguradora";
import SobrevivenciaService from "@/services/SobrevivenciaService";
import BaseSobrevivenciaRequest from "@/models/Sobrevivencia/BaseSobrevivenciaRequest";
import Benefactor from "@/models/Sobrevivencia/Benefactor";
import DistribucionBalance from "@/models/Sobrevivencia/DistribucionBalante/DistribucionBalance";
import { Action, Getter } from "vuex-class";

import { formatCedula } from "@/utils/HelperFunctions";
import NoLoggedUser from "@/models/Sobrevivencia/NoLoggedUser/NoLoggedUser";
import BiometricParams from "@/models/Sobrevivencia/Biometric/BiometricParams";
import VueQr from "vue-qr";
import Swal, { SweetAlertResult } from "sweetalert2";
import Presolicitud from "@/models/Presolicitud";
import GlobalConfig from "@/GlobalConfig";
@Component({
  components: { SquareShadowBox, VueQRCodeComponent, BIconPrinter, VueQr },
})
export default class ValidacionAseguradora extends Vue {
  @Prop() estadoAseguradora: EstadoAseguradora;
  @Prop({ default: 0 }) numSolicitud: number;
  @Prop({ default: "000" }) codUsuario: string;
  @Prop({ default: [] }) benefactors: Benefactor[];
  @Prop({ default: "" }) cartaAseguradoraUrl: string;
  @Prop({ default: "" }) nombreFallecido?: string;
  @Prop({ default: "" }) cedulaFallecido?: string;
  @Prop() currentPresolicitud?: Presolicitud;
  @Getter("currentBenefactor") currentBenefactor: Benefactor;
  @Getter("noLoggedUser") noLoggedUser: NoLoggedUser;
  sobrevivenciaService = new SobrevivenciaService();
  aceptaTerminosBiometrica: boolean = false;
  items: DistribucionBalance[] = [];
  storageSASToken: string;
  fields = [
    {
      key: "nombreBeneficiario",
      label: "Nombre del Beneficiario",
      class: "text-center",
    },
    {
      key: "tipoBeneficiario",
      label: "Tipo Beneficiario",
      class: "text-center",
    },
    {
      key: "porcentajeFormat",
      label: "Porcentaje Para Pagar",
      class: "text-center",
    },
    {
      key: "montoPensionFormat",
      label: "Monto",
      class: "text-center",
    },
  ];
  private async safeGetData() {
    try {
      await this.getData();
    } catch (error) {
      console.error("Error en getData():", error);
    }
  }

  async mounted() {
    await this.safeGetData();
    await this.getStorageSasToken();
  }
  @Watch("numSolicitud")
  async numSolicitudWatch() {
    await this.safeGetData();
  }

  @Watch("benefactors")
  async benefactorsWatch() {
    await this.safeGetData();
  }

  async getData() {
    try {
      let request = new BaseSobrevivenciaRequest(
        "PortalBe",
        this.codUsuario,
        this.numSolicitud
      );
      let responseBalance =
        await this.sobrevivenciaService.getDistribucionBalance(request);

      this.items = [
        ...responseBalance.data.data.filter(
          (x) => x.porcentaje != null && x.porcentaje != 0
        ),
      ];

      this.items.forEach((balance) => {
        this.benefactors.forEach((benefactor) => {
          if (balance.idBeneficiario == benefactor.idBeneficiario) {
            balance.nombreBeneficiario =
              benefactor.primerNombre + " " + benefactor.primerApellido;
            balance.montoPensionFormat =
              "RD$ " + this.numberWithCommas(balance.montoPension.toFixed(2));
            balance.porcentajeFormat = balance.porcentaje + "%";
            balance.tipoBeneficiario = benefactor.nomParentesco;
          }
        });
      });
    } catch (error) {}
  }
  public numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  get biometricLink() {
    // OJO PONER EL LINK EN LA CONFIGURACION
    let biometricParams = new BiometricParams(
      this.currentBenefactor.numPreSolicitud,
      this.currentBenefactor.numIdBeneficiario,
      this.currentBenefactor.cedulaBenefPrincipal,
      this.currentBenefactor.idBeneficiario
    );
    try {
      let crypParams = this.sobrevivenciaService.encryptByDES(
        JSON.stringify(biometricParams)
      );
      return `${GlobalConfig.BIOMETRIC_VALIDATION}/?params=${crypParams}`;
    } catch (e) {
      console.log(e);
    }

    // OJO COLOCAR ESTO EN AJUSTES , variable global
    return `${GlobalConfig.BIOMETRIC_VALIDATION}/?params=$ `;
  }
  public async getStorageSasToken() {
    this.sobrevivenciaService.getStorageSAS().then((resp) => {
      // console.log(resp)
      this.storageSASToken = resp.data;
    });
  }

  get aseguradoraDownloadLink() {
    return `${this.cartaAseguradoraUrl}${this.storageSASToken}&xyz=PT24H`;
  }
  public refrescarPagina() {
    location.reload();
  }

  public abrirTerminos() {
    Swal.fire({
      html:
        '<div style="text-align: justify;font-size: 1rem" class="justify">' +
        '<h5 style="color:#545454">CONSENTIMIENTO PARA CONSULTA Y TRATAMIENTO DE DATOS BIOMÉTRICOS PARA VALIDACIÓN DE IDENTIDAD' +
        "</h5>" +
        "<br/>" +
        " <p>Por el presente documento autorizo a la <b>ADMINISTRADORA DE FONDOS DE PENSIONES SIEMBRA, S. A. (AFP SIEMBRA)</b> para consultar y darle tratamiento a mis datos personales, incluyendo datos biométricos, tales como huellas dactilares, retina e iris de los ojos, patrones faciales, registros de voz y dimensión de las manos, entre otros, suministrados con el diligenciamiento del presente formato o los que suministre a futuro, para: </p>" +
        "<br/>" +
        "<ol>" +
        "<li>Diligenciar, complementar y/o actualizar las bases de datos de <b>AFP SIEMBRA</b></li>" +
        " <li>Tramitar la apertura servicios, productos o solicitudes de beneficios</li>" +
        "<li>Validar mi identidad en el uso de servicios, productos y solicitudes de beneficios</li>" +
        " <li>Para que la validación de mi identidad mediante datos biométricos pueda ser utilizada como medio de prueba. </li>" +
        " </ol>De manera particular, con la imposición de mis huellas dactilares y datos biométricos a través de medios electrónicos, autorizo de manera expresa, informada, previa e inequívoca a <b>AFP SIEMBRA</b> para que valide mis datos, con la finalidad de que, a través de una entidad certificada como operador biométrico o en forma directa, realice la validación de mi identidad contra la base de datos que produce, administra y almacena la JUNTA CENTRAL ELECTORAL.<p></p>" +
        "<br/>" +
        "<p>En relación con esta autorización, manifiesto que he sido informado en forma clara y previa a la imposición de mis huellas dactilares y captura de datos personales sensibles a través de medios electrónicos, acerca de lo siguiente: <b>i</b>. Que el suministro de mis huellas digitales y datos biométricos es facultativo y no obligatorio; <b>ii</b>. Que las huellas digitales y datos personales se entienden como datos personales sensibles, razón por la cual se requiere de mi autorización explícita para el tratamiento de los mismos, de conformidad con lo regulado en los artículos 57 y siguientes de la Ley Orgánica de Actos del Estado Civil núm. 4-23, del 18 de enero de 2023 y la ley núm. 172-13 sobre la Protección Integral de Datos Personales, del 15 de diciembre de 2013; <b>iii</b>. Que la información biométrica consultada de las bases de datos de la Junta Central Electoral, no podrá ser almacenada, ni usada por AFP SIEMBRA para complementar otras bases de datos, ni para fines distintos a los expresados en la presente autorización y en la regulación aplicable, salvo mandato legal o judicial, y serán conservados durante un período mínimo de diez (10) años; <b>iv</b> Que he sido informado sobre mi derecho a revocar la presente autorización, al acceso, a la rectificación, a la supresión, a la oposición y a ejercer en forma gratuita mis derechos y garantías constitucionales.</p>" +
        "<br/>" +
        " <p>Leído lo anterior, autorizo a<b> AFP SIEMBRA</b>, de manera previa, explícita e inequívoca, para la utilización y tratamiento de mi huella dactilar y datos personales sensibles, para las finalidades aquí contempladas. Declaro que soy el titular de la información reportada, y que la he suministrado de forma voluntaria, completa, confiable, informada, veraz, exacta y verídica. </p>" +
        "</div>",
      imageAlt: "A tall image",
      confirmButtonText: "Aceptar",
      confirmButtonColor: "#ed8b2f",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      width: "75%",
    }).then((result) => {
      if (result.isConfirmed) {
        this.aceptaTerminosBiometrica = true;
      }
    });
  }

  get isMobile() {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      // true for mobile device
      return true;
    } else {
      // false for not mobile device
      return false;
    }
  }

  public capitalizeFirstLetter(value: String) {
    if (value != null && value.length > 0) {
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }
  }
  public formatearCedula(value: string) {
    return formatCedula(value);
  }
}
